<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-8">
        <h2>Org Lists:</h2>
        <div class="mt-2 ml--3">
          <tbody>
            <tr v-for="(potentialeeList, index) in orgLists" :key="index">
              <td class="col-md-1">
                <div
                  class="form-control form-control-sm btn-block"
                  id="dropdownMenuButton"
                >{{potentialeeList.name}}</div>
              </td>
              <td class="td-actions col-md-1">
                <button
                  type="button"
                  rel="tooltip"
                  class="btn btn-danger btn-icon btn-sm"
                  data-original-title
                  @click="disableOrgList(potentialeeList)"
                  v-if="potentialeeList.potentialeeIds.includes(potentialee.id)"
                  title
                >
                  <i class="fa fa-minus pt-1"></i>
                </button>
                <button
                  type="button"
                  rel="tooltip"
                  class="btn btn-success btn-icon btn-sm"
                  data-original-title
                  @click="enableOrgList(potentialeeList)"
                  v-else
                  title
                >
                  <i class="fa fa-plus pt-1"></i>
                </button>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr v-for="(pendingPotentialeeList, index) in pendingOrgLists" :key="index">
              <td class="col-md-1">
                <div>
                  <input
                    placeholder="New Org List"
                    v-model="pendingPotentialeeList.name"
                    class="form-control form-control-sm"
                  />
                </div>
              </td>
              <td class="td-actions col-md-1">
                <button
                  type="button"
                  rel="tooltip"
                  class="btn btn-success btn-icon btn-sm"
                  data-original-title
                  @click="addOrgList(pendingPotentialeeList, index)"
                  title
                >
                  <i class="ni ni-check-bold pt-1"></i>
                </button>
                <button
                  type="button"
                  rel="tooltip"
                  class="btn btn-danger btn-icon btn-sm"
                  data-original-title
                  @click="pendingOrgLists.splice(index, 1)"
                  title
                >
                  <i class="fa fa-trash pt-1"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </div>
        <button class="btn btn-primary btn-sm mt-3" @click="pendingOrgLists.push({})">Create</button>
      </div>
      <div class="col-lg-5 col-md-8" v-if="!isOwner">
        <h2>Personal Lists:</h2>
        <div class="mt-2 ml--3">
          <tbody>
            <tr v-for="(potentialeeList, index) in personalLists" :key="index">
              <td class="col-md-1">
                <div
                  class="form-control form-control-sm btn-block"
                  id="dropdownMenuButton"
                >{{potentialeeList.name}}</div>
              </td>
              <td class="td-actions col-md-1">
                <button
                  type="button"
                  rel="tooltip"
                  class="btn btn-danger btn-icon btn-sm"
                  data-original-title
                  @click="disablePersonalList(potentialeeList)"
                  v-if="potentialeeList.potentialeeIds.includes(potentialee.id)"
                  title
                >
                  <i class="fa fa-minus pt-1"></i>
                </button>
                <button
                  type="button"
                  rel="tooltip"
                  class="btn btn-success btn-icon btn-sm"
                  data-original-title
                  @click="enablePersonalList(potentialeeList)"
                  v-else
                  title
                >
                  <i class="fa fa-plus pt-1"></i>
                </button>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr v-for="(pendingPotentialeeList, index) in pendingPersonalLists" :key="index">
              <td class="col-md-1">
                <div>
                  <input
                    placeholder="New Org List"
                    v-model="pendingPotentialeeList.name"
                    class="form-control form-control-sm"
                  />
                </div>
              </td>
              <td class="td-actions col-md-1">
                <button
                  type="button"
                  rel="tooltip"
                  class="btn btn-success btn-icon btn-sm"
                  data-original-title
                  @click="addPersonalList(pendingPotentialeeList, index)"
                  title
                >
                  <i class="ni ni-check-bold pt-1"></i>
                </button>
                <button
                  type="button"
                  rel="tooltip"
                  class="btn btn-danger btn-icon btn-sm"
                  data-original-title
                  @click="pendingPersonalLists.splice(index, 1)"
                  title
                >
                  <i class="fa fa-trash pt-1"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </div>
        <button class="btn btn-primary btn-sm mt-3" @click="pendingPersonalLists.push({})">Create</button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/config/firebase.js";

export default {
  name: "potentialeelists",
  components: {},
  props: {
    potentialee: null
  },
  data() {
    return {
      orgLists: [],
      personalLists: [],
      pendingOrgLists: [],
      pendingPersonalLists: []
    };
  },
  watch: {
    potentialee(newPotentialee, _) {
      this.getPotentialeeLists();
    }
  },
  computed: {
    curOrg() {
      return this.$store.state.usermain.curOrg;
    },
    isOwner() {
      return this.$store.state.usermain.isOwner;
    },
  },
  methods: {
    submit() {},
    async addOrgList(pendingOrgList, index) {
      const orgId = this.curOrg.id;

      if (pendingOrgList.name != undefined) {
        this.pendingOrgLists.splice(index, 1);

        const newOrgList = {
          name: pendingOrgList.name,
          potentialeeIds: [this.potentialee.id]
        };

        console.log(newOrgList);

        await firebase
          .firestore()
          .collection(`organizations/${orgId}/potentialeeLists`)
          .add(newOrgList)
          .catch(e => console.log(e));

        this.getOrganizationPotentialeeLists(orgId);
      }
    },
    async addPersonalList(pendingPersonalList, index) {
      const userId = firebase.auth().currentUser.uid;
      const orgId = this.curOrg.id;

      if (pendingPersonalList.name != undefined) {
        this.pendingPersonalLists.splice(index, 1);

        const newPersonalList = {
          name: pendingPersonalList.name,
          potentialeeIds: [this.potentialee.id]
        };

        console.log(newPersonalList);

        await firebase
          .firestore()
          .collection(`organizations/${orgId}/users/${userId}/potentialeeLists`)
          .add(newPersonalList)
          .catch(e => console.log(e));

        this.getPersonalPotentialeeLists(orgId);
      }
    },
    async enablePersonalList(personalList) {
      const userId = firebase.auth().currentUser.uid;
      const orgId = this.curOrg.id;

      const newPersonalList = {
        name: personalList.name,
        potentialeeIds: personalList.potentialeeIds
      };

      newPersonalList.potentialeeIds.push(this.potentialee.id);

      await firebase
        .firestore()
        .doc(`organizations/${orgId}/users/${userId}/potentialeeLists/${personalList.id}`)
        .set(newPersonalList)
        .catch(e => console.log(e));

      this.getPersonalPotentialeeLists();
    },
    async disablePersonalList(personalList) {
      const userId = firebase.auth().currentUser.uid;
      const orgId = this.curOrg.id;

      const newPersonalList = {
        name: personalList.name,
        potentialeeIds: personalList.potentialeeIds
      };

      newPersonalList.potentialeeIds.splice(
        newPersonalList.potentialeeIds.indexOf(this.potentialee.id),
        1
      );

      await firebase
        .firestore()
        .doc(`organizations/${orgId}/users/${userId}/potentialeeLists/${personalList.id}`)
        .set(newPersonalList)
        .catch(e => console.log(e));

      this.getPersonalPotentialeeLists();
    },
    async enableOrgList(orgList) {
      const userId = firebase.auth().currentUser.uid;
      const orgId = this.curOrg.id;

      const newOrgList = {
        name: orgList.name,
        potentialeeIds: orgList.potentialeeIds
      };

      newOrgList.potentialeeIds.push(this.potentialee.id);

      await firebase
        .firestore()
        .doc(`organizations/${orgId}/potentialeeLists/${orgList.id}`)
        .set(newOrgList)
        .catch(e => console.log(e));

      this.getOrganizationPotentialeeLists();
    },
    async disableOrgList(orgList) {
      const userId = firebase.auth().currentUser.uid;
      const orgId = this.curOrg.id;

      const newOrgList = {
        name: orgList.name,
        potentialeeIds: orgList.potentialeeIds
      };

      newOrgList.potentialeeIds.splice(
        newOrgList.potentialeeIds.indexOf(this.potentialee.id),
        1
      );

      await firebase
        .firestore()
        .doc(`organizations/${orgId}/potentialeeLists/${orgList.id}`)
        .set(newOrgList)
        .catch(e => console.log(e));

      this.getOrganizationPotentialeeLists();
    },
    getPotentialeeLists() {
      this.getPersonalPotentialeeLists();
      this.getOrganizationPotentialeeLists();
    },
    async getOrganizationPotentialeeLists() {
      const orgId = this.curOrg.id;

      const organizationPotentialeeLists = await firebase
        .firestore()
        .collection(`organizations/${orgId}/potentialeeLists`)
        .get()
        .then(querySnapshot => {
          const documents = querySnapshot.docs.map(doc => {
            const docData = doc.data();
            docData.id = doc.id;

            return docData;
          });

          console.log(documents);

          return documents;
        })
        .catch(e => console.log(e));

      console.log(organizationPotentialeeLists);

      this.orgLists = organizationPotentialeeLists;
    },
    async getPersonalPotentialeeLists() {
      const userId = firebase.auth().currentUser.uid;
      const orgId = this.curOrg.id;

      const personalPotentialeeLists = await firebase
        .firestore()
        .collection(`organizations/${orgId}/users/${userId}/potentialeeLists`)
        .get()
        .then(querySnapshot => {
          const documents = querySnapshot.docs.map(doc => {
            const docData = doc.data();
            docData.id = doc.id;

            return docData;
          });

          console.log(documents);

          return documents;
        })
        .catch(e => console.log(e));

      this.personalLists = personalPotentialeeLists;
    }
  }
};
</script>

<style scoped>
</style>
